<script>
import moment from 'moment'
export default {
  name: 'Dateformat',
  methods: {
    dateFormatObjToDateString (myDate) {
      const myMonth = myDate.getMonth() + 1
      const myDay = myDate.getDate()
      return myDate.getFullYear() + '-' + (myMonth < 10 ? '0' : '') + myMonth + '-' + (myDay < 10 ? '0' : '') + myDay
    },
    dateformatObjtotimestring (myDate) {
      const myHours = myDate.getHours()
      const myMinutes = myDate.getMinutes()
      return (myHours < 10 ? '0' : '') + myHours + ':' + (myMinutes < 10 ? '0' : '') + myMinutes
    },
    dateformatObjtotimestringWithSecs (myDate) {
      const myHours = myDate.getHours()
      const myMinutes = myDate.getMinutes()
      const mySeconds = myDate.getSeconds()
      return (myHours < 10 ? '0' : '') + myHours + ':' + (myMinutes < 10 ? '0' : '') + myMinutes + ':' + (mySeconds < 10 ? '0' : '') + mySeconds
    },
    getTimezoneOffsetHoursMinutes (myDate) {
      const offset = Math.abs(myDate.getTimezoneOffset())
      const hours = Math.floor(offset / 60)
      const minutes = offset % 60
      return (myDate.getTimezoneOffset() > 0 ? '-' : '+') + (hours < 10 ? '0' : '') + hours + (minutes < 10 ? '0' : '') + minutes
    },

    currentDatetimeWithTimezoneOffset () {
      const myDate = new Date()
      return this.dateFormatObjToDateString(myDate) + ' ' + this.dateformatObjtotimestringWithSecs(myDate) + ' ' + this.getTimezoneOffsetHoursMinutes(myDate)
    },

    dateformatDbtoweb (datestr, format) {
      if (datestr === '') { return '' }
      return moment(datestr, moment.HTML5_FMT.DATE).format(this.phpToMoment(format))// 'YYYY-MM-DD'
    },
    timeformatDbtoweb (timestr, format) {
      if (timestr === '') { return '' }
      return moment(timestr, moment.HTML5_FMT.TIME).format(this.phpToMoment(format)) // 'HH:mm'
    },
    datetimeformatDbtoweb (datetimestr, format) {
      if (datetimestr === '') { return '' }
      return moment(datetimestr, ['YYYY-MM-DD HH:mm', moment.HTML5_FMT.DATETIME_LOCAL]).format(this.phpToMoment(format))
    },
    datetimezoneformatDbtoweb (datetimestr, format) {
      return moment(datetimestr, 'YYYY-MM-DD HH:mm Z').format(this.phpToMoment(format))
    },
    currentDateFromDateFormat (format) {
      return moment().format(this.phpToMoment(format))
    },
    timeformatDbtoseconds (val, allowSeconds = false) {
      if (typeof val === 'string' && val.includes(':')) {
        const timeArray = val.split(':')
        val = timeArray[0] * 60 * 60 + timeArray[1] * 60 + (allowSeconds && timeArray[2] ? timeArray[2] : 0)
      }
      return parseInt(val)
    },
    datetimeToUnix (datetimestr) {
      if (datetimestr === '') { return '' }
      return moment(datetimestr, ['YYYY-MM-DD HH:mm', moment.HTML5_FMT.DATETIME_LOCAL]).unix()
    },
    gmtToLocalDateAndTimeString (gmtDateTime) {
      return moment(gmtDateTime + 'Z').format(moment.HTML5_FMT.DATETIME_LOCAL)
    },
    gmtToLocalFormat (gmtDateTime, format) {
      return moment(gmtDateTime + 'Z').format(this.phpToMoment(format))
    },
    localDateAndTimeStringToGmt (localDateAndTimeString) {
      return moment(localDateAndTimeString, moment.HTML5_FMT.DATETIME_LOCAL).utc().format('YYYY-MM-DD HH:mm:ss')
    },
    localToLocalDateAndTimeString (dateTime) {
      return moment(dateTime).format(moment.HTML5_FMT.DATETIME_LOCAL)
    },
    localDateAndTimeStringToLocal (localDateAndTimeString) {
      return moment(localDateAndTimeString, moment.HTML5_FMT.DATETIME_LOCAL).format('YYYY-MM-DD HH:mm:ss')
    },
    phpToMoment (str) {
      const replacements = {
        d: 'DD',
        D: 'ddd',
        j: 'D',
        l: 'dddd',
        N: 'E',
        S: 'o',
        w: 'e',
        z: 'DDD',
        W: 'W',
        F: 'MMMM',
        m: 'MM',
        M: 'MMM',
        n: 'M',
        t: '', // no equivalent
        L: '', // no equivalent
        o: 'YYYY',
        Y: 'YYYY',
        y: 'YY',
        a: 'a',
        A: 'A',
        B: '', // no equivalent
        g: 'h',
        G: 'H',
        h: 'hh',
        H: 'HH',
        i: 'mm',
        s: 'ss',
        u: 'SSS',
        e: 'zz', // deprecated since Moment.js 1.6.0
        I: '', // no equivalent
        O: '', // no equivalent
        P: '', // no equivalent
        T: '', // no equivalent
        Z: '', // no equivalent
        c: '', // no equivalent
        r: '', // no equivalent
        U: 'X'
      }

      return str.split('').map(chr => chr in replacements ? replacements[chr] : chr).join('')
    }
  }
}
</script>
